import React, {Fragment } from 'react';
import Helmet from 'react-helmet';

function getDesign() {
    return (
      <Fragment>
        <Helmet>
            <script type="text/javascript">{`!function(r,t,j,s){(j=r.createElement(t)).type="text/javascript",
            j.async=!0,j.charset="utf-8",j.src="//js.rtoaster.jp/RTA-b526-91dfccdc03ed/rt.js",
            (s=r.getElementsByTagName(t)[0]).parentNode.insertBefore(j,s)
            }(document,"script")`}</script>
        </Helmet>
        <div id="rt_y26_jmblogin"></div>
      </Fragment>

    );
}

export {getDesign}
